import {DocumentNode, gql} from "@apollo/client";

export const MASTER_ADDRESSES_QUERY: DocumentNode = gql(`    
    query GetMasterAddresses {
        getMasterAddresses {
            ...MasterAddressInfo
        }
    }
`);
